import { Box, Text } from '@chakra-ui/layout'
import * as React from 'react'
import { Link as GatsbyLink } from 'gatsby'

export const Copyright = (props) => (
  <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
    <Text fontSize="md" {...props}>
      &copy; {new Date().getFullYear()} <strong>Synapse Studios</strong>
    </Text>
    <Text fontSize="sm" textAlign="center">
      <GatsbyLink to="/privacy">Privacy Policy</GatsbyLink> | <GatsbyLink to="/terms">Terms of Use</GatsbyLink>
    </Text>
  </Box>
)
